export default "__VITE_ASSET__CBrdNkfb__"